import { periodisedVariablesStaticGUIElements, periodisedVariablesGUIElements } from '@/services/importingJsons.js'

const periodisedVariables = {
  namespaced: true,
  state: {
    loading: false,
    error: false,
    variables: {
      headings: [],
      options: []
    },
    reportTypes: {
      heading: '',
      options: []
    },
    reportTypesData: {},
    jsonInBackend: {
      data: null
    },
    selected: {
      customReportLink: null,
      reportType: null,
      variables: [],
      periodTypes: []
    }
  },
  mutations: {
    setState (state, payload) {
      state[payload.prop] = payload.value
    },
    selected (state, payload) {
      state.selected[payload.prop] = payload.value
    },
    jsonInBackend (state, payload) {
      state.jsonInBackend[payload.prop] = payload.value
    },
    overwriteSelected (state, newVal) {
      state.selected = newVal
    },
    setDefaultState (state) {
      state.loading = false
      state.error = false
      state.variables = {
        headings: [],
        options: []
      }
      state.reportTypes = {
        heading: '',
        options: []
      }
      state.reportTypesData = {}
      state.selected = {
        variables: [],
        reportType: null,
        periodTypes: []
      }
    },
    setDefaultSelectionState (state) {
      state.selected = {
        customReportLink: null,
        variables: [],
        reportType: null,
        periodTypes: []
      }
    }
  },
  getters: {
    getAllSelections: state => {
      return state.selected
    }
  },
  actions: {
    loadStateFromFile ({ commit, dispatch }, data) {
      dispatch('reset')
      commit('overwriteSelected', data)
    },
    loadStaticData ({ commit }) {
      commit('setState', { prop: 'loading', value: true })
      commit('setState', { prop: 'error', value: false })

      periodisedVariablesStaticGUIElements().then(response => {
        commit('setState', {
          prop: 'reportTypes',
          value: response.reportTypes
        })
        commit('setState', {
          prop: 'reportTypesData',
          value: response.reportTypesData
        })
      }).catch(error => {
        console.error('PeriodisedVariables:getPeriodisedVariablesGuiElements: ', error)
        commit('setState', { prop: 'error', value: true })
      }).finally(() => {
        commit('setState', { prop: 'loading', value: false })
      })
      
    },
    loadDynamicData ({ commit }) {
      commit('setState', { prop: 'loading', value: true })
      commit('setState', { prop: 'error', value: false })

      periodisedVariablesGUIElements().then(response=>{

        commit('setState', {
          prop: 'variables',
          value: response.variables
        })
      }).catch(error => {
        console.error('PeriodisedVariables:getPeriodisedVariablesGuiElements: ', error)
        commit('setState', { prop: 'error', value: true })
      }).finally(() => {
        commit('setState', { prop: 'loading', value: false })
      })
    },
    updateSelection ({ commit }, payload) {
      commit('selected', payload)
    },
    reset ({ commit }) {
      commit('setDefaultState')
      commit('setDefaultSelectionState')
    }
  }
}
export default periodisedVariables
